/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Time_StretchInputs */



/**
* | output |
* | --- |
* | "Apply Time Stretch" |
*
* @param {Apply_Time_StretchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_time_stretch = /** @type {((inputs?: Apply_Time_StretchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Time_StretchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer l’étirement du timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitdehnung anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica Time Stretch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примените растяжение времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar estiramiento de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用时间拉伸")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムストレッチを適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय विस्तार लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar Time Stretch")
	return /** @type {LocalizedString} */ ("Apply Time Stretch")
});